import { Explanation } from '@lessonup/typescript-core/domain';
import { searchClusterRoute } from '@lessonup/typescript-core/services';
import { Modal } from '@lessonup/typescript-core/ui';
import React from 'react';
import { Link } from 'react-router-dom';
import './explanationBox.less';

interface Props {
  explanation: Explanation;
  collapseCount?: number | undefined;
  id: string;
}

interface State {
  isOpen: boolean;
}

export default class ExplanationBox extends React.Component<Props, State> {
  state = { isOpen: false };

  handleOpenClick = (event: React.MouseEvent) => {
    event.stopPropagation();
    this.setState({ isOpen: true });
  };

  handleModalClose = () => {
    this.setState({ isOpen: false });
  };

  render() {
    const { explanation, collapseCount, id } = this.props;

    return (
      <div className="search-explanation-box">
        {collapseCount != null && (
          <Link to={searchClusterRoute(id)} onClick={(e) => e.stopPropagation()}>
            {'collapse: '}
            {collapseCount}{' '}
          </Link>
        )}
        {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events -- auto-generated TECH-258 */}
        <a onClick={this.handleOpenClick} className="search-explanation-box__link">
          {'Score '}
          {explanation.value}
        </a>
        <Modal title="Explanation" isOpen={this.state.isOpen} onRequestClose={this.handleModalClose}>
          <ExplanationItem explanation={explanation} />
        </Modal>
      </div>
    );
  }
}

interface ExplanationItemProps {
  explanation: Explanation;
}

const ExplanationItem = (props: ExplanationItemProps) => {
  return (
    <div className="search-explanation-item">
      <div>
        <b>{props.explanation.value}</b> {props.explanation.description}
      </div>
      <ol>
        {props.explanation.details.map((d, i) => (
          <li key={i}>
            <ExplanationItem explanation={d} />
          </li>
        ))}
      </ol>
    </div>
  );
};
